export interface IntroExportInput {
  backgroundColor: string;
  textColor: string;
  useTwoColors?: boolean;
  textColorSecondary?: string;
  fontFamily: string;
  fontUrl?: string;
  logoUrl?: string;
  logoPosition?: 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-right';
  imageUrl: string;
  text: string;
  textUppercase: boolean;
  /** Effective font size (preview-px) — same value the overlay/preview use. */
  fontSize?: number | null;
  /** Live preview container width; makes canvas-export's scale match the overlay. */
  previewWidth: number;
}

/** Builds the exportTemplateToBlob options for a reel intro frame. Carries the
 *  chosen fontSize + previewWidth so the cover text matches the video overlay
 *  and the live preview (no auto-fit divergence). */
export function buildIntroExportOptions(input: IntroExportInput) {
  return {
    backgroundColor: input.backgroundColor,
    textColor: input.textColor,
    useTwoColors: input.useTwoColors,
    textColorSecondary: input.textColorSecondary,
    fontFamily: input.fontFamily,
    fontUrl: input.fontUrl,
    logoUrl: input.logoUrl,
    logoPosition: input.logoPosition,
    imageUrl: input.imageUrl,
    text: input.text,
    textUppercase: input.textUppercase,
    fitMode: 'fit' as const,
    fontSize: input.fontSize ?? undefined,
    sourceWidth: input.previewWidth,
  };
}
